<template>
  <div class="Adopted">

    <slider :items="items" v-if="adopted" />

  </div>
</template>

<script>
/**
 * NOTE: this is all based off About.vue
 * - The difference is it compiles adopted animals into one big slideshow.
 */
import Slider from 'components/Slider/Slider'

export default {
  name: 'Adopted',

  components: {
    Slider
  },

  watch: {
    '$route.query.page' () {
      this.$analytics.event(`Adopted/Page${this.$route.query.page}`)
    }
  },

  mounted () {
    // Wait a little for the analytics start event to dispatch
    setTimeout(() => {
      this.$analytics.event(`Adopted/Page1`)
    }, 100)
  },

  computed: {
    adopted () { return this.$store.state.recentlyAdopted },

    items () {
      const items = []

      this.adopted.forEach(animal => {
        if (!animal.image) return

        items.push({
          image: animal.image,
          template: 'text',
          content: {
            superTitle: 'Adoption Stories',
            title: animal.name,
            text: animal.aboutDescription
          }
        })

        // Add an additional slider item for the first image
        items.push({ image: animal.image })
      })

      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// Adopted.vue?1eca61e7